"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListModel_1 = require("./ListModel");
var SortUtils_1 = require("../SortUtils");
var OptionListModel = /** @class */ (function (_super) {
    __extends(OptionListModel, _super);
    function OptionListModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionListModel.prototype.getOption = function (key, defaultOption) {
        var option = this.items.find(function (o) {
            return o.key === key;
        });
        return option || defaultOption;
    };
    Object.defineProperty(OptionListModel.prototype, "itemsSorted", {
        get: function () {
            return SortUtils_1.sort(this.itemsView, { field: "text", descending: false });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], OptionListModel.prototype, "itemsSorted", null);
    return OptionListModel;
}(ListModel_1.ListModel));
exports.OptionListModel = OptionListModel;
